import angular from 'angular'
import envRaw from './env-raw'

angular
  .module('ggs.utils')
  .factory('DebugRequest', DebugRequestFactory)

function DebugRequestFactory($log, $q) {
  return function DebugRequest(ownerTag) {
    if (!envRaw.useDebugRequest) {
      return (_requestTag, requestMethod) => requestMethod
    }

    return function debugRequest(requestTag, requestMethod) {
      return function debugRequest_wrapper() {
        $log.force.debug(ownerTag + '#' + requestTag + ' request: ', arguments)
        return requestMethod.apply(this, arguments).then((res) => {
          $log.force.debug(ownerTag + '#' + requestTag + ' success: ', res)
          return res
        }, (err) => {
          $log.force.warn(ownerTag + '#' + requestTag + ' problem: ', err)
          return $q.reject(err)
        })
      }
    }
  }
}
